import injectionHelpers from '@carwow/injection-rules-helpers';

const shouldInjectSideContent = ({
  injectedArray,
  sideContentCount,
}) => sideContentCount === 0 && injectedArray.find((element) => element.type === 'DESKTOP_INLINE_ADVERT');

const shouldInject = (options) => {
  const {
    currentType,
    currentRuleInjectedComponentCount: sideContentCount,
    injectedArray,
    nextType,
  } = options;

  return injectionHelpers.isBetweenTwoTextBlocks({ currentType, nextType })
  && shouldInjectSideContent({ injectedArray, sideContentCount });
};

const sideContentRule = {
  id: 'side-content',
  componentType: 'sideContent',
  condition: (options) => shouldInject(options),
  component: ({
    sideContent,
    localConfig = {},
  }) => injectionHelpers.getConfig({
    localConfig,
    ruleName: 'side-content',
    props: sideContent,
    defaultConfig: [{ type: 'SIDE_CONTENT', props: sideContent }],
  }),
};

export default [
  sideContentRule,
];
